/* eslint-disable */
import { PaynetActionResult } from "@models/C_Transactions";
import { PaymentsCommonErrorCodes } from "@models/MasterData";
import { PaymentMethodConfig } from "@models/payments/PaymentMethodConfig";
import { ErrorService } from "@providers/ErrorService";
import { TrackingService } from "@providers/TrackingService";
import { UserService } from "@providers/UserService";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { PaymentMethodBehaviour, PaymentMethodBehaviourResult, SkipAmountResult } from "./PaymentMethodBase";

export class PaynetMethodBehaviourResult extends PaymentMethodBehaviourResult {
  transactionReference: string;
  transactionCode: string;
  barCodeUrl: string;
  amount: number;
  date: string;
}

export class PaynetSkipAmountResult extends SkipAmountResult {
  transactionReference: string;
  transactionCode: string;
  barCodeUrl: string;
  amount: number;
  date: string;

  constructor() {
    super(true);
  }
}

export class PaynetPaymentMethodBehaviour extends PaymentMethodBehaviour {
  behaviour = PaymentMethodConfig.PAYNET.behaviour;
  name = this.behaviour.name; //"Paynet"
  image = this.behaviour.image; //"Paynet";
  track = this.behaviour.track; //"AccessToPaynet";
  isBank = this.behaviour.isBank; //false;
  minDepositAmount: number;
  maxDepositAmount: number;
  amountButtons: number[] = [300, 400, 800, 1000];

  constructor(userService: UserService, errorService: ErrorService, trackingService: TrackingService) {
    super(false, userService, errorService, trackingService);
  }

  paymentMetodExecution(): Observable<PaynetMethodBehaviourResult> {
    return this.userService.createOpenPayPaynetDeposit(this.amount, "").pipe(
      map((obj) => {
        return this.map(obj);
      }),
      catchError((error, caught) => {
        this.trackCatchError(this.behaviour.name, { err: error, caught: caught });
        return of(<PaynetMethodBehaviourResult>this.getGenericErrorResult());
      }),
    );
  }

  skipAmountInput(): Observable<PaynetSkipAmountResult> {
    const response = this.userService.checkOpenPayPaynetDeposit();
    return response.pipe(map(this.mapSkipAmount));
  }

  private mapSkipAmount(input: PaynetActionResult): PaynetSkipAmountResult {
    const result = new PaynetSkipAmountResult();
    // console.log("############Input Check########")
    if (input.paynetReference !== "") {
      result.skip = true;
      result.amount = input.amount;
      result.transactionCode = input.transactionId;
      result.transactionReference = input.paynetReference;
      result.barCodeUrl = input.barcodeurl;
      result.date = input.duedate;
    } else {
      this.trackGenericError(this.behaviour.name, result);
      result.skip = false;
    }
    // console.log(input);
    // console.log(result);
    return result;
  }

  private map(input: PaynetActionResult): PaynetMethodBehaviourResult {
    const result = new PaynetMethodBehaviourResult();
    if (input.success) {
      // console.log("############Input########")
      result.success = true;
      result.amount = input.amount;
      result.transactionCode = input.transactionId;
      result.transactionReference = input.paynetReference;
      result.barCodeUrl = input.barcodeurl;
      result.date = input.duedate;
      // console.log(input);
      // console.log(result);
    } else {
      this.trackGenericError(this.behaviour.name, result);
      result.success = false;
      result.erroMessage = this.errorService.searchErrorCodeWithParams(
        "error" + input.errCode,
        input.errorParameters,
      );
      result.errorcode = input.errCode;
      result.sendToDocumentVerificationPage =
        input.errCode === PaymentsCommonErrorCodes.MUST_COMPLETE_DOC_VERIFICATION ||
        input.errCode === PaymentsCommonErrorCodes.LIMIT_NOT_VERIFIED_SURPASSED;
    }
    return result;
  }
}
